"use client";
import React from "react";
import { motion } from "framer-motion";
import {
  BsShieldCheck,
  BsLightbulb,
  BsPeople,
  BsBook,
  BsCashCoin,
  BsHeartPulse,
  BsClockHistory,
  BsMortarboard,
  BsAward,
  BsRocketTakeoff,
  BsEnvelopeFill,
  BsTelephoneFill,
} from "react-icons/bs";
import HeaderInner from "../../utility/HeaderInner";

const PrivacyPolicy = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };


  return (
    <motion.div initial="hidden" animate="visible" className="w-100 mt-70">
      <HeaderInner title={"PrivacyPolicy"} />

      {/* Header Section */}
      <motion.div variants={fadeInUp} className="container my-5">
        <h3 className="display-4 fw-bold mb-3">Privacy Policy</h3>
        
        <p className="text-secondary">
          COEMPT EDUTECK is committed to protecting your privacy. That is because we base our business on the trust you place in us. This policy describes our practices regarding personal and account information collected through our Web site. In this policy, 'personal and account information' �means your name, company name, account number, address, telephone number, and e-mail address plus any other information that personally identifies you, including your industry, the number of employees at your company, and purchase history, or would permit us to contact you, and 'we' �and 'us' mean �COEMPT EDUTECK as well as its affiliated companies.<br />
			 We reserve the right to modify this privacy policy from time to time; the effective date noted above will indicate the date that this policy was last updated. You should visit our Web site periodically to review any changes<br/>
			<br/>
        	  The amount and type of information we collect from you depends on your activities and use of our Web site. Below, we explain what information we collect.<br/>
        	  <br/>
        	  IP address - We collect your IP address to measure our Web site traffic and to help provide a relevant shopping experience.�<br/>
        	  <br/>
        	  Referral Web site: If you come to our Web site via a link, we collect the location of the link that referred you.<br/>
        	  <br/>
        	  We collect your name, address and payment information to process your order. However, we WILL NOT store your credit card / bank details<br/>
        	  <br/>
        	  We collect information contained in cookies; such as your purchases and log in data, to personalize your shopping experience. Your browser must be set to accept cookies if you wish to add items to a shopping cart.�<br/>
        	  <br/>
        	  <strong>When you create an E-Account on our Web site</strong><br/>
        	  We collect your user name, password, e-mail address, secret question, and answer to your secret question to protect your E-Account. We use your secret question and answer to identify you as the account user if you have forgotten your password. You can help us ensure your privacy by not sharing your user name or password<br/>
        	  <br/>
        	  You must create an E-Account to subscribe to our e-mail update. We use your E-Account information in connection with your subscription. When you e-mail product information to a friend or colleague through our Web site<br/>
        	  We collect your e-mail address and the e-mail address of the person to whom you are sending the product information.�<br/>
        	  <br/>
        	  <strong>When you request a catalog through our Web site</strong><br/>
        	  We collect your name, address and telephone number. We collect your e-mail address and the other information that you provide in order to respond to your communication<br/>
        	  <br/>
        	  When you enter contests, participate in surveys, or register for other activities on our Web site<br/>
        	  <br/>
        	  We collect your name, e-mail address and telephone number, and the other information that is required for entry or participation, which varies depending on the activity.�<br/>
        	  <br/>
        	  <strong>Is my personal or account information used for any other purpose?</strong><br/>
        	  We may use your personal and account information to provide products or services you have requested, respond to a communication from you, contact you, and as otherwise described in this policy<br/>
        	  <br/>
        	  We may occasionally send you promotional or product information. If you do not wish to receive promotional or product information, you may opt out of future communications by following the instructions in the e-mail communication or contacting your account manager.�<br/>
        	  <br/>
        	  We may also analyze and act upon your personal and account information as part of our standard business practices. We occasionally purchase from third parties commercial information such as company size, number of employees and annual sales of other companies. We may use this commercial information along with your personal and account information to customize our offerings to you, as well as for our internal use.<br/>
        	  <br/>
        	  In addition, in order to measure how we are doing and to better understand how we can improve our product offerings, we or one of our service providers or strategic partners may contact you by telephone or e-mail and solicit your participation in research.<br/>
        	  <br/>
        	  If you become our customer, we may send you updates on important information about our company and services.<br/>
        	  <br/>
        	  <strong>Will my personal and account information be provided to any other party?</strong><br/>
        	  We restrict access to your personal and account information to those who need access to use it as set forth in this policy. Your other personal and account information may be disclosed to third parties in limited circumstances. For example, we may share your personal and account information with our service providers and strategic partners and with suppliers and other entities involved in transactions you have initiated. We may disclose your personal and account information to respond to subpoenas, court orders, or other legal process, as required by law, or to establish or exercise our legal rights or defend against legal claims. Your personal and account information may also be disclosed in connection with a sale of some or all of our business or a merger with another company.<br/>
        	  <br/>
       	    Please note that messages sent by you to us become our property and, unless you direct otherwise, may be used by us for promotional purposes.
        </p>
      </motion.div>

     
      
    </motion.div>
  );
};

export default PrivacyPolicy;
